export const GET_REGISTRY = 'GET_REGISTRY';
export const GET_HEADER_INFO = 'GET_HEADER_INFO';
export const GET_TRAMITS = 'GET_TRAMITS';
export const REPORT_ERROR = 'REPORT_ERROR';
export const RESET_REPORT_ERROR = 'RESET_REPORT_ERROR';